"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickerItem = void 0;
const core_1 = require("@material-ui/core");
const splitTitle_1 = __importDefault(require("@opsbase/lib-general/utils/splitTitle"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const DataIcon_1 = __importDefault(require("@opsbase/web-icons/DataIcon"));
const CheckIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CheckIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importDefault(require("react"));
const Highlight_1 = __importDefault(require("../Highlight"));
const Text_1 = __importDefault(require("../Text"));
function PickerItem(props) {
    const { type, className = '', title: rawTitle, highlight, onClick, avatarUrl, selected = false, } = props;
    const { title, preTitle } = (0, splitTitle_1.default)(rawTitle);
    return (react_1.default.createElement(core_1.ListItem, { className: className, key: `item-${title}`, onClick: onClick },
        react_1.default.createElement(Horizontal_1.default, { stretch: true, gutter: true, centered: true },
            react_1.default.createElement(DataIcon_1.default, { type: type, avatarUrl: avatarUrl }),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(Text_1.default, null,
                    !!preTitle && (react_1.default.createElement(Highlight_1.default, { color: lib_palette_1.default.GreyBlue, search: highlight }, preTitle + ' > ')),
                    react_1.default.createElement(Highlight_1.default, { search: highlight }, title))),
            react_1.default.createElement(Pane_1.default, null, !!selected && react_1.default.createElement(CheckIcon_1.default, { color: lib_palette_1.default.secondary, size: 12 })))));
}
exports.PickerItem = PickerItem;
exports.default = PickerItem;
